import {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../selectors/modules/lucky_wheel/widget';
import {toggleWheel} from '../../../reducers/lucky-wheel/actions';
import {motion} from 'framer-motion';

const format = (time) => {
    const hours = Math.floor(time / (60 * 60 * 1e3));
    time -= hours * (60 * 60 * 1e3);

    const minutes = Math.floor(time / (60 * 1e3));
    time -= minutes * (60 * 1e3);

    const seconds = Math.floor(time / 1e3);

    return `${hours >= 10 ? hours : `0${hours}`}:${minutes >= 10 ? minutes : `0${minutes}`}:${seconds >= 10 ? seconds : `0${seconds}`}`;
}

export default () => {
    const {timeout} = useSelector(Selector),
          dispatch = useDispatch();

    const [time, setTime] = useState(timeout - Date.now());

    useEffect(() => {
        setTime(timeout - Date.now());
    }, [timeout])

    useEffect(() => {
        if(time > 0)
            window.wheel_widget_timer_timeout = setTimeout(() => {
                setTime(timeout - Date.now());
            }, 500);
    }, [time]);

    useEffect(() => {
        return () => window.clearTimeout(window.wheel_widget_timer_timeout);
    }, []);

    return (
        <div className="lucky-wheel-widget" onClick={e => {
            dispatch(toggleWheel());
        }}>
            <div className="background">
                    <motion.div
                        className="logotype"
                        animate={{
                            scale: time <= 0 ? [1, 1.015, 1] : 1,
                        }}
                        transition={{
                            duration: 2,
                            repeat: time <= 0 ? Infinity : 0,
                            ease: 'easeInOut',
                        }}
                    />
                    <motion.div
                        className="circle"
                        animate={{
                            rotate: time <= 0 ? -360 : 0,
                        }}
                        transition={{
                            duration: 3,
                            repeat: time <= 0 ? Infinity : 0,
                            ease: 'linear',
                        }}
                    />
            </div>
            {
                time > 0
                ? <div className="timer">{format(time)}</div>
                : <></>
            }
        </div>
    )
}